module.exports = __webpack_public_path__ + "static/img/pic_11@2x.45715a7d.png";